<template>
    <!-- snackbar from vuetify -->
    <v-snackbar
      :timeout="timeout"
      :color="snackColor"
      v-model="snackbar"
    >
        {{snackText}}
        <v-btn dark flat @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
</template>

<script>
    export default {
        data(){
            return {
                snackbar:       false,
                snackText:      '',
                snackColor:     '',
                timeout:        2000
            }
        },
        created() {
            this.$eventHub.$on('open-snackbar', (color, text, timeout) => {
                this.snackbar   = true
                this.snackColor = color
                this.snackText  = text
                if(timeout) {
                    timeout == ' ' ? this.timeout = null : this.timeout = timeout
                } else {
                    this.timeout = 2000
                }
            })
            this.$eventHub.$on('close-snackbar', () => {
                if(this.snackbar == true) {
                    this.snackbar = false
                }
            })
        },
    }
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/layouts/app/Snackbar.vue